<template lang="html">
  <div class="register-main">
    <img class="cydex-logo" src="../../assets/images/entrance-logo.png" alt="">
    <el-form :model="form" :rules="rules" ref="rulesForm" label-width="100%" label-position="top">
      <el-form-item  :label="message.name" style="text-align:left">
        <el-col :span="24">
          <el-form-item prop="surname" style="text-align:left">
            <el-input v-model.trim="form.surname"></el-input>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="2">&nbsp;</el-col>
        <el-col :span="11">
          <el-form-item prop="name">
            <el-input v-model="form.name" placeholder="名字"></el-input>
          </el-form-item>
        </el-col> -->
      </el-form-item>
      <el-form-item :label="message.email" style="text-align:left" prop="email" auto-complete="off">
        <el-input v-model.trim="form.email"></el-input>
      </el-form-item>
      <el-form-item :label="message.phone" style="text-align:left" prop="phone" auto-complete="off">
        <el-col :span="5"><el-input v-model.trim="form.phone.a" placeholder="86"></el-input></el-col>
        <el-col :span="1">&nbsp;</el-col>
        <el-col :span="18"><el-input v-model.trim="form.phone.b"></el-input></el-col>
      </el-form-item>
      <el-form-item :label="message.pass1" style="text-align:left" prop="pass">
        <el-input type="password" v-model="form.pass"></el-input>
      </el-form-item>
      <el-form-item :label="message.pass2" style="text-align:left" prop="pass2">
        <el-input type="password" v-model="form.pass2"></el-input>
      </el-form-item>
      <el-form-item :label="message.identifying" style="text-align:left" prop="identifying">
        <el-col :span="8">
          <el-input v-model="form.identifying"></el-input>
        </el-col>
        <el-col :span="4">&nbsp;</el-col>
        <el-col :span="12">
          <div class="identifying-main">
            <img class="identifying-img" @click="changeIdentifying" :src="identifyingUrl" alt="">
          </div>
        </el-col>
      </el-form-item>
      <el-form-item prop="rules" class="rules">
         <el-checkbox v-model="form.rules">{{message.Pl149.l0}}<a href="/app/terms" target="_blank">{{message.Pl149.l1}}</a></el-checkbox>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" style="width:100%;margin-top:10px" @click="onSubmit">{{ message.register }}</el-button>
      </el-form-item>
    </el-form>
    <div class="register-register" @click="toRegiser()">
      {{ message.login }}>>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    var checkSurname = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$lang.ui.prompt.l102))
      } else if (value.length > 20) {
        return callback(new Error(this.$lang.ui.prompt.l106))
      } else if (value.length < 2) {
        return callback(new Error(this.$lang.ui.prompt.l107))
      } else {
        callback()
      }
    }
    // var checkName = (rule, value, callback) => {
    //   if (!value) {
    //     return callback(new Error('请输入名字'))
    //   } else {
    //     callback()
    //   }
    // }
    var checkEmail = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$lang.ui.prompt.l100))
      } else {
        callback()
      }
    }
    var checkPhone = (rule, value, callback) => {
      if (!value.b) {
        return callback(new Error(this.$lang.ui.prompt.l151))
      } else {
        callback()
      }
    }
    var checkPass = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$lang.ui.prompt.l101))
      } else if (value.length < 6) {
        return callback(new Error(this.$lang.ui.prompt.l108))
      } else {
        callback()
      }
    }
    var checkPass2 = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$lang.ui.prompt.l103))
      } else if (value !== this.form.pass) {
        callback(new Error(this.$lang.ui.prompt.l105))
      } else {
        callback()
      }
    }
    var checkIdentifying = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$lang.ui.prompt.l104))
      } else {
        callback()
      }
    }
    var checkRules = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$lang.ui.prompt.l148))
      } else {
        callback()
      }
    }
    return {
      message: {
        name: this.$lang.ui.form.name,
        login: this.$lang.ui.form.login,
        pass1: this.$lang.ui.form.pass1,
        pass2: this.$lang.ui.form.pass2,
        email: this.$lang.ui.form.email,
        phone: this.$lang.ui.form.phone,
        register: this.$lang.ui.form.register,
        identifying: this.$lang.ui.form.identifying,
        Pl149: this.$lang.ui.prompt.l149
      },
      identifyingId: '',
      identifyingUrl: '',
      form: {
        surname: '',
        // name: '',
        email: '',
        phone: {
          a: '',
          b: ''
        },
        pass: '',
        pass2: '',
        identifying: '',
        rules: false
      },
      rules: {
        surname: [
          { validator: checkSurname, trigger: 'blur' }
        ],
        // name: [
        //   {validator: checkName, trigger: 'blur'}
        // ],
        email: [
          { validator: checkEmail, trigger: 'blur' }
        ],
        phone: [
          { validator: checkPhone, trigger: 'blur' }
        ],
        pass: [
          { validator: checkPass, trigger: 'blur' }
        ],
        pass2: [
          { validator: checkPass2, trigger: 'blur' }
        ],
        identifying: [
          { validator: checkIdentifying, trigger: 'blur' }
        ],
        rules: [
          { validator: checkRules, trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    this.$store.dispatch('activeApp', true)
    this.identifying_get()
  },
  methods: {
    toRegiser () {
      this.$router.push({ path: '/app/login' })
    },
    identifying_get () {
      this.$http.get('/cydex/api/v1/captcha')
        .then(response => {
          this.identifyingId = response.data.captcha_id
          this.identifyingUrl = response.data.pic_url
        })
    },
    register () {
      if (this.form.phone.a) {
        var phone = this.form.phone.a + '+' + this.form.phone.b
      } else {
        phone = this.form.phone.b
      }
      this.$http.post('/cydex/api/v1/register', {
        'account': this.form.email,
        'user_name': this.form.surname,
        'mobile_phone': phone,
        'password': this.form.pass2,
        'product_code': '001',
        'captcha_id': this.identifyingId,
        'input_value': this.form.identifying
      })
        .then(response => {
          this.$router.push({ path: '/app/notice?mode=reset' })
        })
    },
    onSubmit () {
      this.$refs['rulesForm'].validate((valid) => {
        if (valid) {
          this.register()
        }
      })
    },
    changeIdentifying () {
      this.identifying_get()
    }
  }
}
</script>

<style lang="css" scoped>
.register-main {
  position: absolute;
  display: block;
  width: 420px;
  left: 50%;
  top: 5%;
  border: 1px solid #999;
  border-radius: 8px;
  margin-left: -210px;
  padding: 35px 60px 45px 60px;
}
.register-main .cydex-logo {
  display: block;
  width: 96px;
  margin: 0 auto;
  margin-bottom: 5px;
}
.identifying-main {
  width: 100%;
  height: 36px;
  overflow: hidden;
}
.identifying-img {
  margin-top: -8px;
  width: 100%;
}
.register-register {
  position: absolute;
  bottom: 15px;
  font-size: 15px;
  right: 50px;
  cursor: pointer;
  color: #20a0ff;
}
.rules a {
  color: #20a0ff;
  /*text-decoration: none;*/
}
@media (max-width: 650px) {
  .register-main {
    top: 30px;
    left: 30px;
    right: 30px;
    width: auto;
    margin: 0;
    margin-bottom: 20px;
    padding: 30px 35px 20px 35px;
  }
  .register-main .cydex-logo {
    position: relative;
    width: 96px;
    margin: 0 auto;
    margin-bottom: 20px;
  }
}
</style>
